import caseToCase from './case-to-case';
export default caseToCase('_');
